"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _palette = require("../../theme/palette");

var _palette2 = _interopRequireDefault(_palette);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Colors = () => {
  return _react2.default.createElement(
    _Box2.default,
    null,
    Object.keys(_palette2.default).map(key => {
      const colors = _palette2.default[key];
      return _react2.default.createElement(
        _Flex2.default,
        { key: key },
        _react2.default.createElement(
          _Text2.default,
          null,
          key
        ),
        Object.keys(colors).map(label => _react2.default.createElement(
          _Flex2.default,
          { key: label },
          _react2.default.createElement(_Box2.default, { bg: colors[label], width: 12, height: 12 })
        ))
      );
    })
  );
};
exports.default = Colors;